"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentSerializer = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const assessment_template_serializer_1 = require("../../authoring/serializers/assessment-template.serializer");
const date_helper_1 = require("../../helpers/date.helper");
const common_assessment_serializer_1 = require("./common-assessment.serializer");
class AssessmentSerializer extends dp_http_client_lib_1.PageableSerializer {
    constructor(assessmentTemplateSerializer = new assessment_template_serializer_1.AssessmentTemplateSerializer(), commonAssessmentSerializer = new common_assessment_serializer_1.CommonAssessmentSerializer()) {
        super();
        this.assessmentTemplateSerializer = assessmentTemplateSerializer;
        this.commonAssessmentSerializer = commonAssessmentSerializer;
    }
    serializeOne(data) {
        return {
            id: data.id,
            districtId: data.districtId,
            schoolId: data.schoolId,
            ownerId: data.ownerId,
            contextId: data.contextId,
            contextType: data.contextType,
            startDate: (0, date_helper_1.toLocalDate)(data.startDate),
            endDate: (0, date_helper_1.toLocalDate)(data.endDate),
            finishedAt: (0, date_helper_1.toLocalDate)(data.finishedAt),
            assignedAt: (0, date_helper_1.toLocalDate)(data.assignedAt),
            reopenedAt: (0, date_helper_1.toLocalDate)(data.reopenedAt),
            totalAssigned: data.totalAssigned,
            totalSubmitted: data.totalSubmitted,
            settings: data.settings,
            type: data.type,
            status: data.status,
            bundleId: data.bundleId,
            autoLaunch: data.autoLaunch,
            platformId: data.platformId,
            scorePolicy: data.scorePolicy,
            parentId: data.parentId,
            totalClassStudents: data.totalClassStudents,
            usesCustomRubrics: data.usesCustomRubrics,
            noStudentSubmissionsFlow: data.noStudentSubmissionsFlow,
            assessmentTemplate: data.assessmentTemplate
                ? this.assessmentTemplateSerializer.serializeOne(data.assessmentTemplate)
                : null,
            commonAssessment: data.commonAssessment
                ? this.commonAssessmentSerializer.serializeOne(data.commonAssessment)
                : null,
        };
    }
    serializeStatusSummary({ draft, assigned, closed }) {
        return {
            draft,
            assigned,
            closed,
        };
    }
    serializeAssessmentStatusCount({ open, needsGrading, review, done, paused, assigned, }) {
        return {
            open,
            needsGrading,
            review,
            done,
            paused,
            assigned,
        };
    }
}
exports.AssessmentSerializer = AssessmentSerializer;
//# sourceMappingURL=assessment.serializer.js.map